import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../../redux/slice/system";
import {
  setFormType,
  setFormStep,
  setFormUser,
  setFormDetail,
} from "../../../../redux/slice/form";
import { MainAPI } from "../../../../axios/api";

import { ModulePdfExport } from "../../../../components/exportPdf";

import { Button } from "primereact/button";

export default function ModuleFormStepThks() {
  const route_navigate = useNavigate();
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);

  useEffect(() => {
    dispatch(setProgress(true));
  }, []);

  const finishAction = () => {
    dispatch(setFormType(""));
    dispatch(setFormStep(""));
    dispatch(setFormUser(null));
    dispatch(setFormDetail({}));
    route_navigate("/");
  };

  const sendEmail = ({ file }) => {
    dispatch(setProgress(true));

    let formData = new FormData();
    formData.append("address", redux_form.formUser.email);
    formData.append("upload", file);
    formData.append("attachmentName", "填答結果");

    MainAPI.sendEmail({
      data: formData,
    }).then((result) => {
      const { data } = result;
      if (data[0] === "OK") {
        dispatch(
          setToast({
            severity: "success",
            summary: `寄送 Email 成功`,
            detail: "",
          })
        );
        finishAction();
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `寄送 Email 失敗`,
            detail: "",
          })
        );
      }
      dispatch(setProgress(false));
    });
  };

  return (
    <>
      <div className="text-2xl sm:text-3xl md:text-4xl text-center line-height-3 my-6">
        <div>您好，感謝您閱讀完成本網頁，</div>
        <div>完成以上評估後，</div>
        <div>您可以列印及攜帶此份結果與您的醫師討論。</div>
        <div>是否列印您的資料</div>
      </div>

      <div className="text-center">
        <ModulePdfExport
          className="p-button-warning text-white ml-2 px-4"
          btnLabel="匯出 PDF"
          pdfType={redux_form.formType}
          pdfName="填答結果"
          patientData={redux_form}
          finishAction={() => dispatch(setProgress(false))}
          exportAction={({ file }) => sendEmail({ file })}
        />

        <ModulePdfExport
          className="p-button-warning text-white ml-2 px-4"
          btnLabel="放棄回首頁"
          pdfType={redux_form.formType}
          pdfName="填答結果"
          patientData={redux_form}
          isExport={false}
          finishAction={() => dispatch(setProgress(false))}
          exportAction={({ file }) => sendEmail({ file })}
        />
        {/* <Button
          type="button"
          label="放棄回首頁"
          className="p-button-secondary ml-3 px-3"
          onClick={() => finishAction()}
        /> */}
      </div>
    </>
  );
}
